/// <reference types="@angular/localize" />

import {bootstrapApplication} from '@angular/platform-browser';
import {provideHttpClient} from '@angular/common/http';
import {provideAnimations} from '@angular/platform-browser/animations';
import {provideRouter} from '@angular/router';
import {AppComponent} from './app/app.component';
import {routes} from './app/app.routes';
import {inject, provideAppInitializer} from '@angular/core';
import {ConfigService} from './app/services/config.service';

bootstrapApplication(AppComponent, {
  providers: [
    provideAppInitializer( initializeApp ),
    provideHttpClient(),
    provideAnimations(),
    provideRouter(routes)
  ]
})
  .catch(err => console.error(err));

export function initializeApp() {
  // console.log('initializeApp');

  // const configService = inject( ConfigService );
  // configService.load();
}
